module.exports = __webpack_public_path__ + "301d86548de2abe68c864c61221f7468.MP3";